<template>
    <template v-if='isShowSplash'>

        <Splash />

    </template>

    <template v-else>

        <Header id='header' />
        <Search />
        <Cart />

        <section id='main' class='main' :class='{ "main--is-transitioning": isTransitioning }'>
            <router-view v-slot='{ Component, route }'>
                <transition
                    :name='"vue-" + (route.meta.transition || "fade")'
                    @enter='onTransitionEnter'
                    @afterEnter="onTransitionAfterEnter"
                    @afterLeave="onTransitionAfterLeave">
                    <component :is='Component' :key='route.path' />
                </transition>
            </router-view>
        </section>

        <DevGrid />

    </template>
</template>


<script>
import { mapActions } from 'pinia'
import debounce from 'lodash/debounce'

import { useScrollStore } from '^/stores/scroll'

import Header from '^/components/Header.vue'
import Cart from '^/components/Cart.vue'
import Search from '^/components/Search.vue'
import Splash from '^/components/Splash.vue'
import DevGrid from '^/components/DevGrid.vue'

export default {
    name: 'App',
    data: () => ({
        isShowSplash: window.app?.isSplashEnabled || false,
        isTransitioning: false
    }),
    mounted () {
        this.setupScroller()

        window.addEventListener('resize', this.resize)
        window.addEventListener('orientationchange', this.orientationchange)
        window.addEventListener('appResize', this.appResize)
    },
    beforeUnmount () {
        window.removeEventListener('resize', this.resize)
        window.removeEventListener('orientationchange', this.orientationchange)
        window.removeEventListener('appResize', this.appResize)
    },
    methods: {
        ...mapActions(useScrollStore, [
            'setupScroller',
            'scrollTo',
            'updateScroller',
            'updatePageSizes'
        ]),
        appResize () {
            this.updatePageSizes()
        },

        onTransitionEnter () {
            this.isTransitioning = true

            if (!this.$route.hash) {
                this.scrollTo(0)
            }
        },
        onTransitionAfterEnter () {
            this.isTransitioning = false
        },
        onTransitionAfterLeave () {
            this.updateScroller()

            if (this.$route.hash) {
                this.scrollTo(this.$route.hash)
            }
        },

        // create an abstracted resize event that gets triggered
        // on (debounced) resize and orientation change
        resize: debounce(() => {
            const resizeEvent = new Event('appResize')
            window.dispatchEvent(resizeEvent)
        }, 300),
        orientationchange () {
            const resizeEvent = new Event('appResize')
            window.dispatchEvent(resizeEvent)
        }
    },
    components: {
        Header,
        Cart,
        Search,
        Splash,
        DevGrid
    }
}
</script>
